export default __webpack_public_path__ + "static/media/dentalCare.705fc1c0.svg";